(ns app.front.view.group.admin.fees.reversal-methods.events
  (:require [app.front.entities :as entities]
            [app.front.view.group.admin.fees.reversal-methods.core :as-alias reversal-methods]
            [app.i18n.model :as i18n-model]
            [core.util.string :as str-util]
            [re-frame.core-instrumented :as rf]))

(def reversal-methods-path
  [::reversal-methods/group-admin :fees :reversal-methods])

(rf/reg-event-db ::expand-method
  (rf/path reversal-methods-path)
  (fn [reversal-methods [_ method]]
    (let [method-id          (:db/id method)
          currently-expanded (get reversal-methods :expanded-method-id)]
      (if (= currently-expanded method-id)
        (-> reversal-methods
            (assoc :expanded-method-id nil)
            (update :form-data dissoc method-id)
            (update :unsaved-changes dissoc method-id))
        (-> reversal-methods
            (assoc :expanded-method-id method-id)
            (assoc :assing-new? false)
            (assoc-in [:form-data method-id]
                      {:titles   (i18n-model/strings-map (:bill-reversal-method/titles method))
                       :messages (i18n-model/strings-map (:bill-reversal-method/messages method))
                       :type     (:bill-reversal-method/type method)}))))))

(rf/reg-event-fx
  ::fetch-reversal-methods
  (fn [_ [_ group-id]]
    {:comm/command {:command    :bill/list-reversal-methods
                    :method     :get
                    :on-success [::reversal-methods-fetched]
                    :data       {:authority-group-id group-id}}}))

(rf/reg-event-fx
  ::reversal-methods-fetched
  (fn [_ [_ status body]]
    {:dispatch [::entities/merge-entity-db status (:methods body)]}))

(rf/reg-event-db ::add-new-method
  (rf/path reversal-methods-path)
  (fn [reversal-methods [_]]
    (merge reversal-methods
           {:expanded-method-id :new
            :adding-new?        true
            :form-data          {:new {:titles {} :messages {} :type :bill-reversal-method.type/refund}}})))

(rf/reg-event-db ::cancel-changes
  (rf/path reversal-methods-path)
  (fn [reversal-methods [_ method-id]]
    (if (= method-id :new)
      (-> reversal-methods
          (assoc :expanded-method-id nil)
          (assoc :adding-new? false)
          (update :form-data dissoc :new)
          (update :unsaved-changes dissoc :new))
      (-> reversal-methods
          (update :form-data dissoc method-id)
          (update :unsaved-changes dissoc method-id)))))

(rf/reg-event-fx ::delete-method
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ method-id]]
    {:db           (assoc reversal-methods :deleting-method-id method-id)
     :comm/command {:command    :bill/delete-reversal-method
                    :method     :post
                    :on-success [::method-deleted]
                    :data       {:method-id method-id}}}))

(rf/reg-event-fx ::method-deleted
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ _status _body]]
    (let [method-id (:deleting-method-id reversal-methods)]
      {:db (dissoc reversal-methods :deleting-method-id)
       :fx [[:dispatch [::entities/remove-entity method-id]]
            [:dispatch [:notifications/add :toast :success :success :fee.reversal-method/delete-successfull]]]})))

(defn- valid-reversal-template-form? [form-data]
  (and (some str-util/blank->nil (vals (:titles form-data)))
       (some str-util/blank->nil (vals (:messages form-data)))
       (some? (:type form-data))))

(rf/reg-event-fx ::submit-form
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ method-id]]
    (let [form-data   (get-in reversal-methods [:form-data method-id])
          is-editing? (not= method-id :new)
          valid?      (valid-reversal-template-form? form-data)]
      (if valid?
        {:dispatch [(if is-editing? ::update-method ::create-method) method-id form-data]}
        {:dispatch [:notifications/add :toast :error :error/required-fields-missing
                    :fee.reversal-method/invalid-form]}))))

(rf/reg-event-db ::set-form-data
  (rf/path reversal-methods-path)
  (fn [reversal-methods [_ method-id form-data]]
    (-> reversal-methods
        (assoc-in [:form-data method-id] form-data)
        (assoc-in [:unsaved-changes method-id] true))))

(rf/reg-event-fx ::create-method
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ method-id form-data]]
    (let [group-id (:group-id reversal-methods)]
      {:comm/command {:command    :bill/create-reversal-method
                      :method     :post
                      :on-success [::method-created method-id]
                      :data       {:authority-group-id            group-id
                                   :bill-reversal-method/titles   (:titles form-data)
                                   :bill-reversal-method/messages (:messages form-data)
                                   :bill-reversal-method/type     (:type form-data)}}})))

(rf/reg-event-fx
  ::update-method
  (fn [_ [_ method-id form-data]]
    {:comm/command {:command    :bill/update-reversal-method
                    :method     :post
                    :on-success [::method-updated method-id]
                    :data       {:method-id                     method-id
                                 :bill-reversal-method/titles   (:titles form-data)
                                 :bill-reversal-method/messages (:messages form-data)
                                 :bill-reversal-method/type     (:type form-data)}}}))

(rf/reg-event-fx ::method-created
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ method-id status body]]
    {:db       (-> reversal-methods
                   ;; Collapse and reset after successful creation
                   (assoc :expanded-method-id nil)
                   (assoc :adding-new? false)
                   (update :form-data dissoc method-id)
                   (update :unsaved-changes dissoc method-id))
     :dispatch [::entities/apply-changes status body]}))

(rf/reg-event-fx ::method-updated
  (rf/path reversal-methods-path)
  (fn [{reversal-methods :db} [_ method-id status body]]
    {:db       (-> reversal-methods
                   ;; Collapse the row after successful save
                   (assoc :expanded-method-id nil)
                   (update :form-data dissoc method-id)
                   (update :unsaved-changes dissoc method-id))
     :dispatch [::entities/apply-changes status body]}))

(rf/reg-event-fx ::toggle-activation
  (fn [_ [_ method-id deactivated?]]
    (let [new-state (if deactivated?
                      :bill-reversal-method.state/disabled
                      :bill-reversal-method.state/active)]
      {:comm/command {:command    :bill/toggle-reversal-method-activation
                      :method     :post
                      :on-success [::entities/apply-changes]
                      :data       {:method-id    method-id
                                   :domain/state new-state}}})))
